module.exports = __webpack_public_path__ + "img/user-1.5711d2c3.svg";